<template>
<v-row>

  <template v-if="isCalendarActive">
    <v-col cols="6">
      <card-button
          :selected="isAsSonAsPosible"
          :title="$t('delivery.mode.AS_SON_AS_POSIBLE')"
          icon="bolt"
          @click="asSonAsPosible"
      ></card-button>
    </v-col>
    <v-col cols="6">
      <card-button
          :selected="isScheduled"
          :title="$t('delivery.mode.SCHEDULED')"
          icon="schedule"
          @click="scheduled"
      ></card-button>
    </v-col>

  </template>


  <v-col cols="12" v-else>
    <v-alert  type="warning" class="text-left" rounded text outlined prominent>
      {{ getMessageOutOfTime }}
    </v-alert>
  </v-col>


</v-row>
</template>

<script>
import CardButton from "@/modules/delivery/components/CardButton/CardButton.vue";
import {AS_SON_AS_POSIBLE, SCHEDULED} from "@/modules/delivery/constants/OrderDelivery";

export default {
  name: "CustomerTimeMode",
  components: {CardButton},
  created() {
    if(!this.isCalendarActive){
      this.scheduled();
    }
  },
  computed: {
    isCalendarActive() {
      return this.$store.state.orderStore.orderSystem.isCalendarTakeAwayActive()
    },
    isAsSonAsPosible() {
      return this.$store.state.orderStore.order.isAsSoonAsPossible
    },
    isScheduled() {
      return this.$store.state.orderStore.order.isScheduled
    },
    getMessageOutOfTime() {
      return this.$store.getters.getSetting('MessageOutOfTime').value
    }
  },
  methods: {
    asSonAsPosible() {
      this.$store.commit('orderTimeMode', AS_SON_AS_POSIBLE)
    },
    scheduled() {
      this.$store.commit('orderTimeMode', SCHEDULED)
    },
  }
}
</script>

<style scoped>

</style>
